module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGUlEQVR4nGOIikr9TwlmGDVg1IBRA4aLAQAG0Bgfv4rTrQAAAABJRU5ErkJggg=="